export { default } from './svg/pencil.svg';
